import { Suspense, lazy } from "react";
import { Navigate } from "react-router-dom";
import SuspenseLoader from "src/components/SuspenseLoader";
import BertaGuard from "./_shell/BertaGuard";

// Rotas da Berta — montadas UMA vez em src/router/index.js, dentro de
// /extended-sidebar, como { path: "berta", children: bertaRoutes }.
// Cada módulo só edita as próprias páginas (pastas abaixo); para uma página
// nova do seu módulo, acrescente uma linha aqui no bloco do seu módulo.

const Loader = (Component) => (props) => (
  <Suspense fallback={<SuspenseLoader />}>
    <Component {...props} />
  </Suspense>
);

const Inicio = Loader(lazy(() => import("./Inicio")));
const Configuracoes = Loader(lazy(() => import("./Configuracoes")));
// Pauta + Fontes
const Pauta = Loader(lazy(() => import("./Pauta")));
const PautaDetalhe = Loader(lazy(() => import("./Pauta/Detalhe")));
const Fontes = Loader(lazy(() => import("./Fontes")));
const FonteDetalhe = Loader(lazy(() => import("./Fontes/Detalhe")));
// Espelho + Laudas + Teleprompter
const Espelho = Loader(lazy(() => import("./Espelho")));
const EspelhoEditor = Loader(lazy(() => import("./Espelho/Editor")));
const Lauda = Loader(lazy(() => import("./Lauda")));
const LaudaEditor = Loader(lazy(() => import("./Lauda/Editor")));
const Teleprompter = Loader(lazy(() => import("./Teleprompter")));
// Brutos (+ Checagem, que vive dentro da Lauda)
const Bruto = Loader(lazy(() => import("./Bruto")));
const BrutoVisualizador = Loader(lazy(() => import("./Bruto/Visualizador")));
// ✦ Montar o jornal (fluxo único) + Revisão do jornal
const MontarJornal = Loader(lazy(() => import("./Jornal/Montar")));
const RevisaoJornal = Loader(lazy(() => import("./Jornal/Revisao")));
const ImprimirEspelho = Loader(lazy(() => import("./Espelho/Imprimir")));

const guard = (permissionKey, Componente) => (
  <BertaGuard permissionKey={permissionKey}><Componente /></BertaGuard>
);

const bertaRoutes = [
  { path: "", element: <Navigate to="inicio" replace /> },
  { path: "inicio", element: guard("berta", Inicio) },
  { path: "configuracoes", element: guard("berta", Configuracoes) },

  { path: "pauta", element: guard("berta_pauta", Pauta) },
  { path: "pauta/:id", element: guard("berta_pauta", PautaDetalhe) },
  { path: "fontes", element: guard("berta_fontes", Fontes) },
  { path: "fontes/:id", element: guard("berta_fontes", FonteDetalhe) },

  { path: "espelho", element: guard("berta_espelho", Espelho) },
  { path: "espelho/:id", element: guard("berta_espelho", EspelhoEditor) },
  { path: "espelho/:id/revisao", element: guard("berta_laudas", RevisaoJornal) },
  { path: "espelho/:id/imprimir", element: guard("berta_espelho", ImprimirEspelho) },
  { path: "montar", element: guard("berta_espelho", MontarJornal) },
  { path: "laudas", element: guard("berta_laudas", Lauda) },
  { path: "laudas/:id", element: guard("berta_laudas", LaudaEditor) },
  { path: "teleprompter", element: guard("berta_tp", Teleprompter) },

  { path: "brutos", element: guard("berta_brutos", Bruto) },
  { path: "brutos/:id", element: guard("berta_brutos", BrutoVisualizador) },
];

export default bertaRoutes;
